/**
 * Delta Trust Carousel - Initialize Swiper when section enters viewport
 */
(function(window) {
  'use strict';
  
  // Namespace for delta trust carousel
  window.DeltaTrustCarousel = window.DeltaTrustCarousel || {
    initialized: false,
    instances: new Map()
  };
  
  /**
   * Initialize a trust carousel instance
   * @param {string} sectionId - Section ID
   * @param {string} anchorId - Anchor ID
   */
  window.DeltaTrustCarousel.init = function({sectionId, anchorId, mobileSpacing = 10, desktopSpacing = 20}) {
    // Check if already initialized for this section
    const instanceKey = `${sectionId}-${anchorId}`;
    if (window.DeltaTrustCarousel.instances.has(instanceKey)) {
      return;
    }
    
    const sectionElement = document.getElementById(anchorId);
    const swiperElement = document.querySelector(`[data-section-id="${sectionId}"].delta-trust-swiper`);
    
    if (!sectionElement || !swiperElement) {
      // Retry if DOM not ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          window.DeltaTrustCarousel.init({sectionId, anchorId});
        });
      }
      return;
    }
    
    let swiperInstance = null;
    let isInitialized = false;
    
    const initCustomSwiper = () => {
      if (isInitialized) return;
      
      swiperInstance = swiperElement.globalSlide;
      if (!swiperInstance) {
        setTimeout(initCustomSwiper, 100);
        return;
      }
      
      isInitialized = true;
      window.DeltaTrustCarousel.instances.set(instanceKey, {
        swiperInstance: swiperInstance,
        swiperElement: swiperElement
      });
      
      // Update spacing based on CSS variable and screen size
      const updateSpacing = () => {
        const isMobile = window.innerWidth <= 768;
        const spacingVar = isMobile 
          ? mobileSpacing
          : desktopSpacing;
        
        if (spacingVar) {
          const spacingValue = parseInt(spacingVar) || 20;
          swiperInstance.params.spaceBetween = spacingValue;
          swiperInstance.update();
        }
        console.log(swiperInstance, spacingVar)
      };
      
      // Initial spacing update
      updateSpacing();
      
      // Handle window resize with debounce
      let resizeTimer;
      const handleResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          updateSpacing();
        }, 250);
      };
      
      window.addEventListener('resize', handleResize, { passive: true });
    };
    
    // Use Intersection Observer to initialize when section enters viewport
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry && entry.isIntersecting && !isInitialized) {
          initCustomSwiper();
          observer.disconnect();
        }
      }, {
        rootMargin: '50px',
        threshold: 0.01
      });
      
      observer.observe(sectionElement);
    } else {
      // Fallback for browsers without IntersectionObserver
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCustomSwiper);
      } else {
        initCustomSwiper();
      }
    }
  };
  
  window.DeltaTrustCarousel.initialized = true;
})(window);
